import { Languages } from 'lucide-react';
import { useLanguage } from './LanguageProvider.jsx';

export default function LanguageToggle() {
  const { language, setLanguage, t } = useLanguage();
  const next = language === 'ar' ? 'en' : 'ar';
  return <button type="button" className="language-toggle" onClick={() => setLanguage(next)}
    aria-label={t('language.switch')} title={t('language.switch')} lang={next} dir={next === 'ar' ? 'rtl' : 'ltr'}>
    <Languages aria-hidden="true"/><span>{next === 'en' ? 'English' : 'العربية'}</span>
  </button>;
}
